import React, { useState } from "react";
import "./contact.css";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !message) {
      setError("Please fill in the missing fields.");
    } else {
      setError("");
      // submit the form
    }
  };

  return (
    <div id="contact" className="contact__main">
      <div>
        <h1 className="contact__headertext">Write us a letter</h1>
        <h3 className="contact__subheader">We appreciate you ideas</h3>
      </div>
      <form className="contact__container" onSubmit={handleSubmit}>
        <div className="contact__header">
          <h3 className="contact__label">NAME</h3>
          <div>
            <input
            className="contact__textbox"
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>

        <div className="contact__header">
          <h3 className="contact__label">EMAIL ADDRESS:</h3>
          <div>
            <input className="contact__textbox"
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>

        <div className="contact__header">
          <h3 className="contact__label">YOUR MESSAGE</h3>
          <div>
            <textarea
            className="contact__textbox"
              placeholder="Example Text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
        </div>

        <div className="contact__header">
          {error && <p style={{ color: "red" }}>{error}</p>}
          <button className="contact__btn" type="submit">Submit</button>
        </div>


      </form>
    </div>

  );
};

export default Contact;
